import { ProfileActionsSheet } from './profile-actions-sheet';
import { type useSharingPlaceMembers } from 'app/network/sharing-place';
import { AmbassadorBottomSheet } from '../../../profile/ambassador/ambassador-bottom-sheet';
import { DiscountDetailBottomSheet } from '../bottom-sheets/discount-details';
import { JoinPlaceBottomSheet } from '../bottom-sheets/join-place';
import { LeavePlaceBottomSheet } from '../bottom-sheets/leave-place';
import { OpeningHoursBottomSheet } from '../bottom-sheets/opening-hours';
import { PlaceMembersBottomSheet } from '../bottom-sheets/place-members';
import { SharingPlaceHelpBottomSheet } from '../bottom-sheets/sharing-place-help';
import type { PlaceDetails, ProfileNavigation } from './shared';

export function ProfileBottomSheets({
  ambassador,
  actions,
  place,
  report,
}: {
  actions: React.ComponentProps<typeof ProfileActionsSheet>;
  ambassador: React.ComponentProps<typeof AmbassadorBottomSheet>;
  place?: {
    details: PlaceDetails;
    discount: Pick<React.ComponentProps<typeof DiscountDetailBottomSheet>, 'onClose' | 'open'>;
    help: Pick<React.ComponentProps<typeof SharingPlaceHelpBottomSheet>, 'onClose' | 'open'>;
    join: Omit<React.ComponentProps<typeof JoinPlaceBottomSheet>, 'onClose'> & { onClose: () => void };
    leave: Omit<React.ComponentProps<typeof LeavePlaceBottomSheet>, 'onClose'> & { onClose: () => void };
    members: NonNullable<ReturnType<typeof useSharingPlaceMembers>['data']>;
    membersSheet: Pick<React.ComponentProps<typeof PlaceMembersBottomSheet>, 'onClose' | 'open'>;
    navigation: ProfileNavigation;
    openingHours: Pick<React.ComponentProps<typeof OpeningHoursBottomSheet>, 'onClose' | 'open'>;
  };
  report: {
    onClose: () => void;
    onConfirm: () => void;
    open: boolean;
  };
}) {
  return (
    <>
      <AmbassadorBottomSheet {...ambassador} />
      <ProfileActionsSheet
        {...actions}
        open={actions.open || report.open}
        onClose={report.open ? report.onClose : actions.onClose}
        confirmReport={report.open ? report.onConfirm : undefined}
      />
      {place ? (
        <>
          <OpeningHoursBottomSheet {...place.openingHours} placeDetails={place.details} />
          <JoinPlaceBottomSheet {...place.join} />
          <SharingPlaceHelpBottomSheet {...place.help} placeDetails={place.details} />
          <LeavePlaceBottomSheet {...place.leave} />
          <DiscountDetailBottomSheet {...place.discount} discount={place.details.discount} />
          <PlaceMembersBottomSheet {...place.membersSheet} members={place.members} navigation={place.navigation} />
        </>
      ) : null}
    </>
  );
}
